import { useState } from 'react'
import classNames from 'classnames'

import Button from '@components/Button'
import { airportsSelector } from 'wordpress/selectors'
import { EXTERNAL_FLOW } from '../constants'
import { getCurrentLink } from '../helpers'

import styles from '../styles.module.scss'

const AirportsView = ({ airportsData }) => {
    const [isItemHovered, setIsItemHovered] = useState(null)

    const handleHover = index => {
        setIsItemHovered(index)
    }

    const handleLeave = () => {
        setIsItemHovered(null)
    }

    const itemLinkHoveredClass = index => (isItemHovered === index ? styles.airportsListItemHover : '')

    return (
        <div className={styles.airportsContainer}>
            <div className="container">
                <h2 className={classNames('text-center', styles.pageTitle)}>
                    <T>airports.title</T>
                </h2>
                {airportsData ? (
                    <div className={styles.airportsList}>
                        {airportsData.map((airport, index) => (
                            <div
                                className={classNames(styles.airportsListItem, itemLinkHoveredClass(index))}
                                key={index}>
                                <img className={styles.airportsImage} src={airport.image.url} />
                                <p className={classNames('text-extra-large', 'text-center', styles.airportLabel)}>
                                    {airport.name}
                                </p>
                                <Button
                                    onMouseEnter={() => handleHover(index)}
                                    onMouseLeave={handleLeave}
                                    btnStyle="brand-button brand-button--primary"
                                    size="small"
                                    external={airport.type === EXTERNAL_FLOW}
                                    href={getCurrentLink(airport)}
                                    className="ml-1"
                                    on>
                                    {airport.action_button_label}
                                </Button>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className="text-extra-large text-center">
                        <T>airport.no.location.added.label</T>
                    </p>
                )}
            </div>
        </div>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            airportsData: airportsSelector,
        })
    )
)(AirportsView)
